import {Option} from 'platform/components';

import {isNilOrEmpty} from 'ramda-adjunct';

import {CustomerResponseBodyV2} from '@dms/api/customer';
import {BaseSupplierOrderVariantSupplier} from '@dms/api/warehouse';
import {getOptionsFromCustomersAsSupplier} from '@dms/shared';

import {Nullish} from 'shared/web';

export const getOptionsFromSuppliersByOrderVariant = (
  suppliers: CustomerResponseBodyV2[] | Nullish,
  supplierOrderVariantSuppliers: BaseSupplierOrderVariantSupplier[] | Nullish
): Option[] => {
  if (isNilOrEmpty(suppliers)) {
    return [];
  }

  const availableSupplierIds = new Set(
    supplierOrderVariantSuppliers?.map((availableSupplier) => availableSupplier.supplierId)
  );

  return getOptionsFromCustomersAsSupplier(
    suppliers?.filter((supplier) => availableSupplierIds.has(supplier.id))
  );
};
